import { Intent } from 'signup-constants/Intent';
import { getIntentKey } from '../routing/getIntentKey';
import { isIntent } from '../utils/isIntent';
import { getQueryParams } from '../routing/getQueryParams';
import { getHublet, getIsNewUser } from '../store/app/selectors';
import { getAuthUserId, getPortalId } from '../store/auth/selectors';
import { IntentLinks } from './intentLinks';
import { getEmailSignatureGeneratorState } from '../store/microapp/selectors';
export const doesIntentLinkExist = () => {
  const intentKey = getIntentKey();
  return intentKey && IntentLinks.has(intentKey);
};
export const getIntentLink = (state, portalId = getPortalId(state), hublet = getHublet(state)) => {
  const queryParams = getQueryParams();
  const intentKey = getIntentKey();
  const isExistingUser = !getIsNewUser(state);
  const intentLink = IntentLinks.get(intentKey);
  const contactVid = getEmailSignatureGeneratorState(state).contactVid;
  if (isIntent(Intent.trial) && isExistingUser) {
    queryParams['existing_account'] = 'true';
  }
  if (isIntent(Intent.emailSignatureEmailTool) && Boolean(contactVid)) {
    queryParams['vid'] = `${contactVid}`;
  }
  let intentRedirectHref;
  if (doesIntentLinkExist() && intentLink) {
    queryParams['userId'] = `${getAuthUserId(state)}`;
    intentRedirectHref = intentLink(portalId, hublet, queryParams);
  }
  return intentRedirectHref;
};